export const isValidUsername = (str: string) => str !== undefined && (str.length === 11 || str.indexOf('_admin') > -1)

export const isExternal = (path: string) => /^(https?:|mailto:|tel:)/.test(path)
